@if (question.question_prompt === 'products' && editModal===false) {
  @for (category of getProductCategories(); track category) {
    <ul class="everything-products everything-products--questionnaire everything-products--{{category}} list-unstyled">
      @for (product of getProducts(category); track product) {
        <li>
          <div class="everything-products__copy">
            <label>{{product.product_name}}</label>
            <h4>{{product.short}}</h4>
            <p>{{product.product_description}}</p>
          </div>
          <a href="javascript:void(0);" (click)="selectOption(product.product_id)" [class]="'button button--' + category + '-gradient'">Get a Quote</a>
        </li>
      }
    </ul>
  }
}

@if (question.question_prompt === 'categories' && editModal===false) {
  @for (category of categories; track category) {
    <ul class="claim-categories list-unstyled">
      <li class="claim-categories--{{category.css}}">
        <a href="javascript:void(0);" (click)="selectOption(category.product_category_id)" data-product="true" class="claim-categories__item">
          <div class="claim-categories__item-content">
            <svg-icon src="assets/{{category?.product_category_id}}/logo.svg" class="img-fluid fill-{{category.css}}" [applyClass]="true"></svg-icon>
            <p>{{category.category_description}}</p>
          </div>
          <div class="claim-categories__btn-select">
            <svg class="icon"><use xlink:href="#right-small"></use></svg>
          </div>
        </a>
      </li>
    </ul>
  }
}

@if (question.question_prompt === 'policies' && editModal===false) {
  <ul class="claim-categories claim-categories--sm list-unstyled">
    @for (policy of policies; track policy) {
      <li class="claim-categories--{{policy?.category_name.substring(0, policy?.category_name.indexOf('.')).toLowerCase()}}">
        <a href="javascript:void(0);" (click)="selectOption(policy.policy_id)" data-product="true" class="claim-categories__item">
          <div class="claim-categories__item-policy">
            <div class="claim-categories__item-company">
              <div class="claim-categories__item-company-thumb">
                <img [src]="'assets/insurer/' + parseJSON(policy.ratings)[0]?.insurer_id + '.svg'" class="img-fluid" />
              </div>
              <div class="claim-categories__item-company-rating">
                <div class="stars">
                  @for (star of parseJSON(policy.ratings)[0]?.star_css?.split('|'); track $index) {
                    <div class="stars__star">
                      <svg class="icon"><use xlink:href="#star-inactive"></use></svg>
                      <div class="stars__percent stars__percent--{{star}}">
                        <svg class="icon"><use xlink:href="#star-active"></use></svg>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="claim-categories__item-details">
              <div class="claim-categories__item-details-category">{{policy.policy_id}}</div>
              <div class="claim-categories__item-details-name">
                <h6>{{policy.product_name}}</h6>
              </div>
              <div class="claim-categories__item-details-cost">
                <p>
                  <strong>
                    <em>R {{policy.premium}}</em>
                  </strong>
                  /{{policy.frequency_short}}
                </p>
              </div>
            </div>
          </div>
          <div class="claim-categories__btn-select">
            <svg class="icon"><use xlink:href="#right-small"></use></svg>
          </div>
        </a>
      </li>
    }
  </ul>
  <div class="mt-20 mt-md-30 text-center">
    <a href="javascript:void(0);" (click)="goToPreviousQuestion()" class="button-control">
      <svg class="icon">
        <use xlink:href="#left-small"></use>
      </svg>
      <strong>Back</strong>
    </a>
  </div>
}

@if (readOnly && editModal) {
  <div class="form-group form-group--lg mb-1'">
    <label [innerHtml]="question?.email_version ? question?.email_version : question?.question_copy">
    </label>
    @if (question.question_prompt === 'categories') {
      <input [name]="uniqueControlName" [id]="uniqueControlName" type="text"
        [value]="getCategoryName(question?.answer)" disabled="true" class="form-control">
    }
    @if (question.question_prompt !== 'categories') {
      <input [name]="uniqueControlName" [id]="uniqueControlName" type="text"
        [value]="question?.answer" disabled="true" class="form-control">
    }
  </div>
}
